import {
  formatDate,
  BaseTransaction,
  formatBalance,
  BaseellaStatusTitle,
  SelectItemProps,
  Currency,
} from '@ui/src';
import getGeneralLedgerStatusTitle from '../../general-ledger/helpers/get-gl-enum-names';
import { PaymentType } from '../../../store/types';

import cn from '../../incoming/styles.module.css';

const formatOutgoingList = ({
  list,
  countries,
  currenciesList,
  paymentTypes,
}: {
  list: BaseTransaction[];
  countries?: SelectItemProps[];
  currenciesList?: Currency[];
  paymentTypes?: PaymentType[];
}): BaseTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const currentCurrency = currenciesList?.find(
      (currency) => currency.id === result.currencyId,
    );

    const currentPaymmentType = paymentTypes?.find(
      (type) => type.paymentType === item.paymentType,
    );

    const render: Record<string, any> = {
      transferDate: (
        <div>{formatDate(result?.transferDate || '', true) || '—'}</div>
      ),
      acceptedOut: <div>{formatDate(result?.acceptedOut || '') || '—'}</div>,
      currencyId: <div>{result?.currency?.name || ''}</div>,
      recipientAccountNumber: result?.recipientAccount ? (
        <>
          <div>{result?.recipientAccount?.description}</div>
          <div className={cn.accNumber}>
            {result?.recipientAccount?.fullNumber}
          </div>
        </>
      ) : (
        result.recipientAccountNumber
      ),
      senderAccountNumber: result?.senderAccount ? (
        <>
          <div>{result?.senderAccount?.description}</div>
          <div className={cn.accNumber}>
            {result?.senderAccount?.fullNumber}
          </div>
        </>
      ) : (
        result.senderAccountNumber
      ),
      benificiaryCountry: (
        <div>
          {
            countries?.find(
              (country) => country.value === result.benificiaryCountry,
            )?.name
          }
        </div>
      ),
      benificiaryBankCountry: (
        <div>
          {countries?.find(
            (country) => country.value === result.benificiaryBankCountry,
          )?.name || '-'}
        </div>
      ),
      intermediaryBankCountry: (
        <div>
          {
            countries?.find(
              (country) => country.value === result.intermediaryBankCountry,
            )?.name
          }
        </div>
      ),
      paymentType: <div>{currentPaymmentType?.name}</div>,
      sum: (
        <div>
          {result.sum ? formatBalance(result.sum, currentCurrency) : ''}
        </div>
      ),
      documentNumber: (
        <div className={cn.documentInfoRow}>{result.documentNumber}</div>
      ),
      info: <div className={cn.documentInfoRow}>{result.info}</div>,
      baseellaStatus: <div>{BaseellaStatusTitle[result.baseellaStatus]}</div>,
    };

    result.render = render;

    const nextResult = {
      ...result,
      values:
        result.generalLedgerTransactions?.edges.map((el) => {
          const gl = el.node;

          const glCurrency = currenciesList?.find(
            (currency) => currency.id === gl?.currency.id,
          );

          return {
            ...gl,
            render: {
              transferDate: (
                <div>{formatDate(gl?.transferDate || '', true)}</div>
              ),
              currencyId: <div>{gl?.currency.name || ''}</div>,
              debitAccountId: <div>{gl?.debitAccount?.fullNumber || ''}</div>,
              creditAccountId: <div>{gl?.creditAccount?.fullNumber || ''}</div>,
              debitAccount: <div>{gl?.debitAccount?.description || ''}</div>,
              creditAccount: <div>{gl?.creditAccount?.description || ''}</div>,
              sum: <div>{gl.sum ? formatBalance(gl.sum, glCurrency) : ''}</div>,
              status: (
                <div>{getGeneralLedgerStatusTitle(gl?.status || '')}</div>
              ),
            },
          };
        }) || [],
    };

    return nextResult;
  });

  return nextList;
};

export default formatOutgoingList;
